var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVolleyballServe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  clipPath: "url(#volleyballServe_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.969 5.289c-.187-.449-.874-2.358.038-4.232a3.5 3.5 0 0 0-1.77 4.394l.01.024c.574.08 1.192 0 1.722-.186m3.318-.206c-.372.49-1.637 1.95-3.592 2.125a3.5 3.5 0 0 0 3.052.284 3.5 3.5 0 0 0 1.49-1.075 3.8 3.8 0 0 0-.95-1.334"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.286 5.084a3.56 3.56 0 0 0-1.773-.866c-.41.489-.943.859-1.545 1.071a3.76 3.76 0 0 1-1.721.187c.289.75.808 1.345 1.447 1.733 1.955-.176 3.22-1.636 3.592-2.125"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.007 1.056C8.096 2.93 8.783 4.84 8.97 5.288a3.56 3.56 0 0 0 1.545-1.072 3.56 3.56 0 0 1-.16-1.852c.101-.56.343-1.143.703-1.606a3.5 3.5 0 0 0-2.05.298"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.353 2.365c-.111.62-.056 1.26.16 1.851a3.56 3.56 0 0 1 1.774.867c.392.354.744.827.95 1.333.449-.558.72-1.244.769-1.963-1.141-1.66-3.085-2.018-3.653-2.088"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.354 2.365c.568.07 2.51.427 3.652 2.088a3.5 3.5 0 0 0-2.95-3.695 3.76 3.76 0 0 0-.702 1.607M4.88 6.288l-.436-1.625a.75.75 0 0 0-1.406.502L3.5 6.894"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.423 14.762 1.735 5.45a4.6 4.6 0 0 1-.074-.844l.012-2.593A.783.783 0 0 1 3.237 2l.048 2.392a.75.75 0 0 1 1.16.27l.634 2.367c.086.323.086.664 0 .986l-.239.89c-.12.457-.136.794.005 1.21l1.685 5.202"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "volleyballServe_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgVolleyballServe;